import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import { favoritesAPI } from '../services/api';

const FavoritesContext = createContext();

export const useFavorites = () => useContext(FavoritesContext);

export const FavoritesProvider = ({ children }) => {
  const { user } = useAuth();
  const [favoriteIds, setFavoriteIds] = useState(new Set());

  useEffect(() => {
    if (!user) {
      setFavoriteIds(new Set());
      return;
    }
    favoritesAPI.getIds()
      .then(ids => setFavoriteIds(new Set(ids)))
      .catch(() => {});
  }, [user]);

  const isFavorite = useCallback((productId) => favoriteIds.has(productId), [favoriteIds]);

  const toggleFavorite = useCallback(async (productId) => {
    if (!user) return false;
    try {
      const res = await favoritesAPI.toggle(productId);
      setFavoriteIds(prev => {
        const next = new Set(prev);
        if (res.status === 'added') next.add(productId);
        else next.delete(productId);
        return next;
      });
      return res.status;
    } catch {
      return false;
    }
  }, [user]);

  return (
    <FavoritesContext.Provider value={{ favoriteIds, isFavorite, toggleFavorite }}>
      {children}
    </FavoritesContext.Provider>
  );
};
